import React, {useState} from "react";

import { graphql } from "gatsby";
import { useTranslation } from 'gatsby-plugin-react-i18next';

import {Tabs} from "@mantine/core";

import Section from "../../components/Section";
import Layout from "../../components/Layout";
import WeightDiary from "../../components/WeightDiary";
import WeightGraphDiary from "../../components/WeightGraphDiary";
import FoodDiary from "../../components/FoodDiary";

export default function Diary(props) {
	const { t } = useTranslation();
	const [activeTab, setActiveTab] = useState(0);

	return (
		<>
			<Layout location={props.location}>
				<Section title={" "}>
					<Tabs
						active={activeTab}
						onTabChange={setActiveTab}
						className={"w-full"}
						styles={{
							tabControl: {height: "60px", width: "33%"},
							tabsList: {justifyContent: "space-between"},
							root: {margin: 0},
						}}
					>
						<Tabs.Tab label={t("diary_weight_tab")}>
							<WeightDiary/>
						</Tabs.Tab>
						<Tabs.Tab label={t("diary_weight_graph_tab")}>
							<WeightGraphDiary/>
						</Tabs.Tab>
						<Tabs.Tab label={t("diary_food_tab")}>
							<FoodDiary/>
						</Tabs.Tab>
					</Tabs>
				</Section>
			</Layout>
		</>
	);
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;